<template>
<div class="content">
    <div class="container-fluid" v-if="loading">
        <div class="row">
            <div class="col-xl-12">
                <h2>Loading...</h2>
            </div>
        </div>
    </div>
    <div class="container-fluid" v-if="!loading">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <span class="nav-link" data-cy='reservations-tab' v-bind:class="{active: showRIs}" @click="toggleShowRIs">Active Reservations ({{Object.keys(filteredReservations).length}})</span>
            </li>
            <li class="nav-item">
                <span class="nav-link" data-cy='investments-tab' v-bind:class="{active: showInvestments}" @click="toggleShowInvestments">Investments per date ({{Object.keys(investment_list).length}})</span>
            </li>
        </ul>
        <div class="active-reservations" v-if="showRIs">
            <span >Reservation Portfolio</span></br>
            <button @click='showFilters=!showFilters' data-cy="switch-filters">Show/Hide Filters</button>
            <div data-cy="filters" v-if="showFilters">
                <multiselect class='multiselect' data-cy="select_regions" v-model="regions_filter" placeholder="Select Regions" label="name" track-by="code" :options="options['regions']" :multiple="true" :taggable="true"></multiselect>
                <multiselect class='multiselect' data-cy="select_services" v-model="services_filter" placeholder="Select Services" label="name" track-by="code" :options="options['services']" :multiple="true" :taggable="true"></multiselect>
                <multiselect class='multiselect' data-cy="select_nodetypes" v-model="nodetypes_filter" placeholder="Select Node Types" label="name" track-by="code" :options="options['nodetypes']" :multiple="true" :taggable="true"></multiselect>
            </div>
            <div >
                <b-table  data-cy="reservation-list"  striped hover :fields="fields" :items="filteredReservations">
                </b-table>
            </div>
        </div>
        <div class="reinvestment" v-if="showInvestments">
            
            <b-table  data-cy="investment-list"  striped hover :fields="investment_fields" :items="investment_list">
            </b-table>
        </div>
    </div>
</div>
</template>

<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios'
import Multiselect from 'vue-multiselect'

import {
    colors,
    formatMoney,
    formatSimple,
    formatSimple2d,
    chart_base
} from 'src/globalVariables'
import {
    setInterval
} from 'timers';
import chartist from 'chartist'

Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

// const groupBy = (items, key) => items.reduce(
//   (result, item) => ({
//     ...result,
//     [item[key]]: [
//       ...(result[item[key]] || []),
//       item['instance_count'],
//     ],
//   }), 
//   {},
// );

export default {
    components: {
        LTable,
        ChartCard,
        StatsCard,
        Multiselect,
    },
    async created() {
        this.accessToken = await this.$auth.getAccessToken()
        this.loadData()
        var vm = this
        setInterval(function () {
            vm.loadData()
        }, vm.refresh_minutes * 60 * 1000)

    },
    methods: {
        toggleShowRIs: function (){
            this.showRIs = !this.showRIs
            this.showInvestments = !this.showInvestments
        },
        toggleShowInvestments: function (){
            this.showRIs = !this.showRIs
            this.showInvestments = !this.showInvestments
        },
        loadData: function () {
            var today = new Date();
            this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
            console.log('refreshing...', )
            axios
                .get('/aws/reservation/portfolio?access_token=' + this.accessToken)
                .then(response => {
                    this.reservations = response.data
                    this.loadFilters()
                    this.filterReservations()
                })
            this.loading = false;
            return true
        },
        loadFilters: function(){
            /// create the lists for the filters based on distinct keys from the data
            this.regions_filter = []
            var vm = this
            var regions = {}
            var services = {}
            var nodetypes={}
            this.reservations.forEach( function(reservation) {
                regions[reservation.region_id] = reservation.region_id
                services[reservation.service_name] = reservation.service_name
                nodetypes[reservation.node_type] = reservation.node_type
            })
            Object.keys(regions).forEach(function (r) {
                vm.options.regions.push({'code':r, 'name':r})
            })
            Object.keys(services).forEach(function (s) {
                vm.options.services.push({'code':s, 'name':s})
            })
            Object.keys(nodetypes).forEach(function (n) {
                vm.options.nodetypes.push({'code':n, 'name':n})
            })
        },
        filterReservations: function(){
            var vm = this
            this.filteredReservations = []
            this.reservations.forEach(function (reservation) {
                var regionPassed = false
                var servicePassed = false
                var nodetypePassed = false
                vm.regions_filter.forEach( function(region){
                    if (region.code == reservation.region_id) {
                        regionPassed = true
                    }
                })
                if (vm.regions_filter.length == 0) regionPassed = true

                vm.services_filter.forEach( function(service){
                    if (service.code == reservation.service_name) {
                        servicePassed = true
                    }
                })
                if (vm.services_filter.length == 0) servicePassed = true
                
                vm.nodetypes_filter.forEach( function(nodetype){
                    if (nodetype.code == reservation.node_type) {
                        nodetypePassed = true
                    }
                })
                if (vm.nodetypes_filter.length == 0) nodetypePassed = true
                    
                if (regionPassed && servicePassed && nodetypePassed)
                    vm.filteredReservations.push(reservation)
                
            })
            this.summarize_investments()
        },
        summarize_investments: function () {
            /// sumarizes the invesments in RIs per end_date. Updates this.investment_list
            
            this.investment_list = []
            var invesment_dict = {}
            // var investment_dict_per_duration = groupBy(this.filteredReservations,'end_date')
            var vm = this
            this.filteredReservations.forEach(function(reservation){
                if (!(reservation['end_date'] in invesment_dict))
                    invesment_dict[reservation['end_date']] = 0
                invesment_dict[reservation['end_date']] += parseFloat(reservation['investment'])
            }) 
            // console.log(invesment_dict)
            Object.entries(invesment_dict).forEach(function(value){
                vm.investment_list.push({'date':value[0], 'investment':value[1]})
                })
            
        },
    },
    watch: {
        regions_filter: function(){
            this.filterReservations()
        },
        services_filter: function(){
            this.filterReservations()
        },
        nodetypes_filter: function(){
            this.filterReservations()
        },
    },
    computed: {

    },
    data() {
        return {
            showRIs: true,
            showInvestments: false,
            showFilters:false,
            options: {
                "regions": [],
                "services": [],
                "nodetypes": [],
            },

            accessToken: '',
            refresh_minutes: 30,
            last_update: '',
            colors: colors,
            loading: true,
            regions_filter:[],
            services_filter:[],
            nodetypes_filter:[],
            fields:[
                {key: "region_id", sortable: true,
                    thStyle: { 'min-width':'120px', 'max-width':'120px'},
                
                },
                {key: "service_name", sortable: true},
                {key: "node_type", sortable: true},
                {key: "product_description", sortable: true},
                {key: "instance_count", sortable: true,
                    thStyle: { 'min-width':'90px', 'max-width':'90px'},
                },
                {key: "reservation_id", sortable: true,
                    thStyle: { 'min-width':'330px', 'max-width':'330px'},
                },
                {
                    // A virtual column with date calculation
                    key: 'Days Remaining', sortable: true,
                    formatter: (value, key, item) => {
                        var date1 = new Date();
                        var date2 = new Date(item.end_date);
                        var difference = Math.round(date2.getTime() - date1.getTime())/ (1000 * 3600 * 24);
                        return difference.toFixed(0)
                    }
                },
                {key: "start_date", sortable: true,
                    thStyle: { 'min-width':'110px'},
                },
                {key: "end_date", sortable: true,
                    thStyle: { 'min-width':'110px'},
                },
                {key: "usage", sortable: true,
                        thStyle: { 'min-width':'100px'},
                        formatter: (value, key, item) => Math.round(value)+' %'
                },
                {key: "investment", sortable: true,
                        thStyle: { 'min-width':'100px'},
                         formatter: (value, key, item) => formatMoney.format(value)
                },
            ],
            reservations: [
            ],
            filteredReservations: [],
            investment_fields:[
                {key: "date", sortable: true,
                    thStyle: { 'min-width':'110px'},
                },
                {key: "investment", sortable: true,
                    thStyle: { 'min-width':'110px'},
                         formatter: (value, key, item) => formatMoney.format(value)
                },

            ],
            investment_list:[],
            
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect {
    max-width: 80%;
}
</style>
